/*jshint esversion: 9 */
import { mapGetters } from 'vuex';

import ProjectStructureTreeTaktplan from '@/components/ProjectStructure/ProjectStructureTreeTaktplan.component.vue';
// import ProjectStructureTaktplanTaktareas from '@/components/ProjectStructure/ProjectStructureTaktplanTaktareas.component.vue';
export const TaktPlanMixin = {
  components: {
    ProjectStructureTreeTaktplan,
    // ProjectStructureTaktplanTaktareas
  },
  data: () => ({
    getTaktplanMoveVariables: {},
    waggon_transition: true,
    draggable_disabled: true,
    show_spatial_structure: true,
    project_taktplan_spatial_header_width: 248,
    // project_taktplan_spatial_header_width1: 248,

  }),
  computed: {
    ...mapGetters('ProjectStructure', [
      'getChildElements',
      'getTaktareasForSpatialStructure',
    ]),

    is_collapsed() {
      if (this.location === 'HistProject') {
        return this.getUObject({type: 'histtrains', id: this.project.histtrains[0]}).closed;
      } else {
        return this.getUObject({type: 'trains', id: this.project.trains[0]}).closed;
      }
    },
    // getWidth() {
    //   return parseInt(getComputedStyle(document.body).getPropertyValue('--project_taktplan_spatial_header_width'));
    // },
  },
  methods: {
    setWidth(width) {
      document.body.style.setProperty('--project_taktplan_spatial_header_width', width);
    },
    // changeDescriptionValue(closed, payload){
    //   if (closed) {
    //     // train
    //     this.trainChangeValue(payload);
    //   } else {
    //     // taktarea
    //     this.taktareaChangeValue(payload);
    //   }
    // },
    moveTaktPlanMouseDown(evt) {
      if (evt.buttons === 4) {
        this.getTaktplanMoveVariables = Object.assign(this.getTaktplanMoveVariables, {
          initial_mouse_x: evt.pageX,
          initial_mouse_y: evt.pageY,
          initial_page_x: this.$refs.taktplan.$el.scrollLeft,
          initial_page_y: this.$refs.taktplan.$el.scrollTop,
        });
      }
    },
    moveTaktPlanMouseMove(evt) {
      if (evt.buttons === 4) {
        this.$refs.taktplan.$el.scrollLeft = this.getTaktplanMoveVariables.initial_page_x - (evt.pageX - this.getTaktplanMoveVariables.initial_mouse_x);
        this.$refs.taktplan.$el.scrollTop = this.getTaktplanMoveVariables.initial_page_y - (evt.pageY - this.getTaktplanMoveVariables.initial_mouse_y);
      }
    },
    toggleWaggonTransition() {
      this.waggon_transition = false;
      let self = this;
      setTimeout(function () {
        self.waggon_transition = true;
      }, 1000);
    },
    getHeaderRowBorder(prop, value, new_milestone, color) {
      if (!['TrainMilestonesAdd', 'TrainMilestonesDetails', 'TrainMilestonesEdit']
          .includes(this.$route.name)) {
            return color;
      } else if (['TrainMilestonesDetails', 'TrainMilestonesEdit']
          .includes(this.$route.name) && this.milestone_selection[prop].findIndex(entry => entry.id === value.id) !== -1) {
            return 'var(--v-primary-base)';
      } else if (this.$route.name === 'TrainMilestonesAdd' && new_milestone.milestone[prop].findIndex(entry => entry.id === value.id) !== -1){
            return 'var(--v-primary-base)';
      } else {
        return '';
      }
    },
    handleHeaderRowClick(train, taktarea) {
      if (this.$route.name === 'TrainMilestonesAdd' && this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
        this.editNewMilestoneSelection({
            project_id: this.project_id,
            prop: train.closed?'trains':'taktareas',
            value: train.closed?train:taktarea,
          });
      } else if (this.$route.name === 'TrainMilestonesEdit' &&
        this.getMileStoneLinkType({
          project_id: this.project_id,
          milestone_id: this.$route.params.milestone_id
        }) === 'selection') {
          this.editMilestoneSelection({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id,
            prop: train.closed?'trains':'taktareas',
            value: train.closed?train:taktarea,
          });
        }
    },
    toggleAllTrains() {
      let closed = false;
      if (!this.getUObject({type: 'trains', id: this.project.trains[0]}).closed) {
        closed = true;
      }
      this.project.trains.forEach(train_id => {
        this.updateUDObject({
          url: [
            {projects: this.project_id},
            {trains: train_id}
          ],
          update: {
            closed: closed
          }
        });
      });
      this.project.wbgroups.forEach(wbgroup_id => {
        this.updateUDObject({
          url: [
            {projects: this.project_id},
            {wbgroups: wbgroup_id}
          ],
          update: {
            closed: closed
          }
        });
      });
    },
    toggleAllHistTrains() {
      let closed = false;
      if (!this.getUObject({type: 'histtrains', id: this.project.histtrains[0]}).closed) {
        closed = true;
      }
      this.project.histtrains.forEach(train_id => {
        this.updateUDObject({
          url: [
            {projects: this.project_id},
            {histtrains: train_id}
          ],
          update: {
            closed: closed
          }
        });
      });
      this.project.histwbgroups.forEach(wbgroup_id => {
        this.updateUDObject({
          url: [
            {projects: this.project_id},
            {histwbgroups: wbgroup_id}
          ],
          update: {
            closed: closed
          }
        });
      });
    }
  }
};
